<template>
  <div class="monthbutton">
    <MiniButton v-on="$listeners">
      {{ buttonText }}
    </MiniButton>
  </div>
</template>

<script>
import { ja } from 'vuejs-datepicker/dist/locale'
import { format } from 'date-fns'
import MiniButton from '@/components/parts/MiniButton.vue'
export default {
  name: 'MonthPickerWithArrow',
  components: {
    MiniButton
  },
  props: {
    value: {
      type: Date,
      default: null
    },
    format: {
      type: String,
      default: 'yyyy年M月'
    }
  },
  data() {
    return {
      ja
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    buttonText() {
      return format(this._value, this.format)
    }
  },
}
</script>

<style lang="scss">
.monthbutton {
  display: flex;
  align-items: center;

  &__button {
    border: none;
    background-color: transparent;
    color: $primary;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 32px;
    }
  }
}

</style>